import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { AssetModalDesktopLayout } from "~/components/AssetModal/AssetModalDesktopLayout";
import { useFullscreenContext } from "~/components/AssetModal/shared/context/FullscreenContext";
import { useAssetModalEscKeyHandler } from "~/components/AssetModal/shared/hooks/useAssetModalEscKeyHandler";
import { PublicImageVisualizer } from "~/components/AssetModal/Visualizer/ImageVisualizer/PublicImageVisualizer";
import { PublicPDFVisualizer } from "~/components/AssetModal/Visualizer/PDFVisualizer/PublicPDFVisualizer";
import { Visualizer } from "~/components/AssetModal/Visualizer/Visualizer";
import { PublicAssetModalFooter } from "~/components/PublicAssetModal/components/PublicAssetModalFooter";
import { PublicPreviousAndNextArrows } from "~/components/PublicAssetModal/components/PublicPreviousAndNextArrows";
import { PublicVideoVisualizer } from "~/components/PublicAssetModal/components/PublicVideoVisualizer";
import { PublicBoardAssetModalHeader } from "./PublicBoardAssetModalHeader";
import { PublicBoardAssetModalPanel } from "./PublicBoardAssetModalPanel";
export const PublicBoardAssetModalDesktopLayout = /*#__PURE__*/ memo(()=>{
    useAssetModalEscKeyHandler();
    const { isFullscreen } = useFullscreenContext();
    const showArrows = !isFullscreen;
    return /*#__PURE__*/ _jsx(AssetModalDesktopLayout, {
        arrows: showArrows ? /*#__PURE__*/ _jsx(PublicPreviousAndNextArrows, {}) : undefined,
        header: /*#__PURE__*/ _jsx(PublicBoardAssetModalHeader, {}),
        panel: /*#__PURE__*/ _jsx(PublicBoardAssetModalPanel, {
            showArrows: showArrows
        }),
        content: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Visualizer, {
                    PDFVisualizer: PublicPDFVisualizer,
                    VideoVisualizer: PublicVideoVisualizer,
                    ImageVisualizer: PublicImageVisualizer
                }),
                /*#__PURE__*/ _jsx(PublicAssetModalFooter, {})
            ]
        })
    });
});
PublicBoardAssetModalDesktopLayout.displayName = "PublicBoardAssetModalDesktopLayout";
